import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_MDFYAPP_SRCH_COND,
    SG_MDFYAPP_LST,
} from "@/tz/go/egaz/osci/lpco/app/service/OsciLpcoAprvService";
import { APP_STAT_PPUP } from "../../comn/APP_STAT_PPUP";

/**
 * !== 정정/취소 신청서 목록 ==!
 */
export const OSCI0201015Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: [
            "auth_osci0006",
            "auth_osci0008",
            "auth_osci0015",
            "auth_osci0016",
            "auth_osci0018",
            "auth_osci0017",
            "auth_osci0007",
        ],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth: any = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0121" },
            { area: "comnCd", comnCd: "OSC0129" },
        ],
    });

    const location = useLocation();
    let errmsg: any;

    // Application LIST
    const [appCdNoList, setAppCdNoList] = useState([]);

    useEffect(() => {
        grid.mdfyAppLst.setShow("column", "asnmtOfcrNm", true);
        handler.setInit();
    }, []);

    useEffect(() => {
        handler.setInit();
    }, [location.pathname]);

    /*
     * Modify Approval Application List Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Amendment Approval Application list search conditions !== 정정 심사 신청서 목록 검색 조건 ==!
        mdfyAppSrchCond: useForm({
            defaultSchema: SF_MDFYAPP_SRCH_COND,
            defaultValues: {
                ...(pgeStore?.form || {
                    srchSbmsDtStart: comnUtils.getDate({ m: -1 }),
                    srchSbmsDtEnd: comnUtils.getDate(),
                }),
            },
        }),
    };

    /*
     * Modify Approval Application List Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Amendment Approval Application List !== 정정 심사 신청서 목록  ==!
        mdfyAppLst: useGrid({
            defaultSchema: SG_MDFYAPP_LST,
            page: 0,
            size: 10,
        }),
    };

    const fetch = {
        // Application List !== Application 목록 ==!
        getAppCdNoList: useFetch({
            api: (data) => {
                return lpcoUtils.getOrgLpcoList(auth.get("orgCd"));
            },
            onSuccess: (data) => {
                setAppCdNoList(data || []);
                // Show Approval No under Assigned Officer when the organization uses an approval number pattern !== 기관이 승인번호 채번 규칙을 쓰면 배정담당자 아래 승인번호 표시 ==!
                if ((data || []).some((item: any) => item.aprvNoPtnCd)) {
                    grid.mdfyAppLst.setShow("column", "asnmtOfcrNm", false);
                    grid.mdfyAppLst.setShow("column", "asnmtOfcrAprvNo", true);
                }
            },
            onError: () => {
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
        getMdfyAppList: useFetch({
            api: (page = grid.mdfyAppLst.page) => {
                // const orgInfoParam: any = srchOrgInfo;
                return APIS.getMdfyAppList(
                    { ...form.mdfyAppSrchCond.getValues(), srchOrgCd: auth.get("orgCd"), menuTp: "APP" },
                    page,
                    grid.mdfyAppLst.size,
                );
            },
            enabled: comnUtils.isEmpty(form.mdfyAppSrchCond.errors) && form.mdfyAppSrchCond.isSubmitted,
            key: [grid.mdfyAppLst.page, grid.mdfyAppLst.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.mdfyAppSrchCond.getValues(),
                    srchOrgCd: auth.get("orgCd"),
                    menuTp: "APP",
                    page: grid.mdfyAppLst.page,
                    size: data.mdfyAppList.page.totalSize,
                });
            },
            onError: (error) => {
                errmsg =
                    error.response?.data.errorCode == -1
                        ? "msg.osc.00015"
                        : error.response?.data.errorMessage || "msg.osc.00015";

                modal.openModal({
                    content: errmsg,
                });
            },
            showToast: false,
        }),
        // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
        updateReceived: useFetch({
            api: (appId, appStatCd) => {
                return APIS.updateReceived(appId, appStatCd);
            },
            onSuccess: (data, param) => {
                navigate(URLS.osci0201016s + "/" + param[0], { state: { menuTp: "APP", appId: param[0] } });
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
            showToast: false,
        }),
    };

    const handler = {
        setInit: async () => {
            await fetch.getAppCdNoList.fetch();
            handler.getMdfyAppList();

            grid.mdfyAppLst.setShow("column", "btnRcve", false);
        },
        getMdfyAppList: (page: number = 0) => {
            form.mdfyAppSrchCond.handleSubmit(async () => {
                grid.mdfyAppLst.setPage(page);
                await fetch.getMdfyAppList.fetch();
            })();
        },
        // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
        updateReceived: async (appId: any, appStatCd: any) => {
            fetch.updateReceived.fetch(appId, appStatCd);
        },
    };

    const render = {
        grid_mdfyAppLst: {
            head: {},
            cell: {
                appNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    const param = { menuTp: "APP", appId: rowValues.appId };
                    return (
                        <Layout direction="col" gap={1}>
                            <Link
                                to={`${URLS.osci0201016s}/${rowValues.appId}`}
                                state={param}
                            >{`${rowValues.appNo}`}</Link>
                        </Layout>
                    );
                },
                appStatNm: (props: any) => {
                    const { binding, rowValues, value } = props;
                    const param = {
                        appUuid: rowValues.appUuid,
                        orgCd: rowValues.orgCd,
                        appCdNo: rowValues.appCdNo,
                        appTpCd: rowValues.appTpCd,
                        appStatCd: rowValues.appStatCd,
                    };
                    console.log(rowValues);
                    return (
                        <Link
                            to={""}
                            state={param}
                            onClick={() => {
                                modal.openModal({
                                    content: (
                                        <APP_STAT_PPUP
                                            paramData={{
                                                appUuid: rowValues.appUuid,
                                                orgCd: rowValues.orgCd,
                                                appCdNo: rowValues.appCdNo,
                                                appTpCd: rowValues.appTpCd,
                                                appStatCd: rowValues.appStatCd,
                                                /* 서버가 신청 원본에서 신청 유형을 판정한다. 아래 값은 appId 가 없을 때만 쓰인다. */
                                                appId: rowValues.appId,
                                                lpcoAplyTpCd: rowValues.amdTpCd,
                                            }}
                                            callbackFn={(data: any) => {
                                                modal.closeModal();
                                                window.location.reload();
                                            }}
                                        />
                                    ),
                                    size: "sm",
                                    height: 200,
                                });
                            }}
                        >{`${rowValues.appStatNm}`}</Link>
                    );
                },
            },
        },
    };

    return (
        <Page
        // id={pgeUid}
        // title={t(pgeTitle)}
        // navigation={{
        //     base: lpcoEnvs.base,
        //     nodes: [...BASE.nodes, { path: "/E", label: pgeTitle }], // !== TODO path 추가구현 필요 ==!
        // }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchAppNo} />
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchUcrNo} />
                        </Group.Row>

                        {/* <Group.Row>
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchTin} controlSize={10} />
                        </Group.Row> */}

                        <Group.Row>
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchAmdTpCd} />
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchAppCdNo} options={appCdNoList} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control
                                {...form.mdfyAppSrchCond.schema.srchSbmsDt}
                                rangeButton={0}
                                controlSize={10}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control
                                {...form.mdfyAppSrchCond.schema.srchAprvDt}
                                rangeButton={0}
                                controlSize={10}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchAppStatCd} excludes={["DR", "SP"]} />
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchCstmOfceCd} />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={async () => {
                                    // form.mdfyAppSrchCond.reset();
                                    form.mdfyAppSrchCond.setValues({
                                        srchAppNo: null,
                                        srchUcrNo: null,
                                        srchAmdTpCd: null,
                                        srchAppCdNo: null,
                                        srchSbmsDtStart: comnUtils.getDate({ m: -1 }),
                                        srchSbmsDtEnd: comnUtils.getDate(),
                                        srchAprvDtStart: null,
                                        srchAprvDtEnd: null,
                                        srchAppStatCd: null,
                                    });
                                    handler.getMdfyAppList();
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={async () => {
                                    handler.getMdfyAppList();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.mdfyAppLst.grid}
                            data={fetch.getMdfyAppList.data?.mdfyAppList}
                            render={render.grid_mdfyAppLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
